import React from "react";
import { GiHamburgerMenu } from "react-icons/gi";
import styled from "styled-components";

const SC = {};
SC.Hamburger = styled.button`
.icon {
  transition: all .3s ease;
  transform: rotate(0deg);
}
&.burger-open {
  .icon {
    transition: all .3s ease;
    transform: rotate(90deg);
  }
}
`;

const Hamburger = ({ isMobile, isBurgerOpen, setIsBurgerOpen, headerRef, setHeaderHeight }) => {
  const handleBurger = () => {
    const open = isBurgerOpen
    setIsBurgerOpen(!open)
    if(!open) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }
  return (
    <SC.Hamburger className={isBurgerOpen ? "burger-open" : "burger-closed"} onClick={handleBurger}>
      <GiHamburgerMenu className="icon" />
      {isMobile ? <span>Menu</span> : null}
    </SC.Hamburger>
  );
};

export default Hamburger;
